import { dates } from './dates'
import { notifications } from './notifications'
import { images } from './images'
import { transports } from './transports'

export const mixin = {
  dates,
  notifications,
  images,
  transports
}



// WEBPACK FOOTER //
// ./src/mixins/index.js